export class Pager {
    totalPages: number;
    currentPage: number;
    pages: any;
    pageSize: number;
}
